var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.36121 2.30052C4.82168 1.88082 5.54493 1.9035 5.97662 2.35118L12 8.59765L18.0234 2.35118C18.4551 1.9035 19.1783 1.88082 19.6388 2.30052C20.0993 2.72022 20.1226 3.42337 19.6909 3.87105L13.1429 10.6616V11.697H17.1429C17.774 11.697 18.2857 12.1944 18.2857 12.8081C18.2857 13.4217 17.774 13.9192 17.1429 13.9192H13.1429V15.6566H17.1429C17.774 15.6566 18.2857 16.154 18.2857 16.7677C18.2857 17.3813 17.774 17.8788 17.1429 17.8788H13.1429V20.8889C13.1429 21.5025 12.6312 22 12 22C11.3688 22 10.8571 21.5025 10.8571 20.8889V17.8788H6.85715C6.22596 17.8788 5.71429 17.3813 5.71429 16.7677C5.71429 16.154 6.22596 15.6566 6.85715 15.6566H10.8571V13.9192H6.85715C6.22596 13.9192 5.71429 13.4217 5.71429 12.8081C5.71429 12.1944 6.22596 11.697 6.85715 11.697H10.8571V10.6616L4.3091 3.87105C3.87741 3.42337 3.90074 2.72022 4.36121 2.30052Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYen);
export default __webpack_public_path__ + "static/media/yen.3a950f8eae3253568d39bdb23a4383ed.svg";
export { ForwardRef as ReactComponent };